<template>
<div class="section">
  <form @submit="login">
    <div class="card card-rounded column is-half is-offset-one-quarter is-paddingless">
      <header class="card-header modal-card-head">
        <p class="card-header-title modal-card-title">Login</p>
      </header>
      <section class="card-content">
        <b-message type="is-danger" :active.sync="isLoginError">
            Foutieve inlog
        </b-message>

        <b-field label="Email">
          <b-input
            v-model="uid"
            type="email"
            placeholder="Jouw email"
            required>
          </b-input>
        </b-field>

        <b-field label="Password">
          <b-input
            v-model="password"
            type="password"
            password-reveal
            placeholder="Jouw wachtwoord"
            required>
          </b-input>
        </b-field>

        <b-checkbox v-model="rememberMe">Onthoud mij</b-checkbox>
      </section>
      <footer class="card-footer modal-card-foot">
        <button
          v-bind:class="{ 'is-loading': isLoading }"
          class="button is-primary"
          @click="login">Login</button>
      </footer>
    </div>
  </form>
</div>
</template>

<script>
import moment from 'moment';

export default {
  data() {
    return {
      uid: '',
      password: '',
      isLoginError: false,
    }
  },
  computed: {
    isLoading() {
      return this.$store.getters.isLoadingAuth;
    },

    rememberMe: {
      get: function() {
        return this.$store.getters.rememberMe;
      },

      set: function(v) {
        this.$store.dispatch('setRememberMe', v)
          .then(() => {

          })
          .catch(err => console.error(err));
      }
    },
  },
  methods: {
    login(e) {
      e.preventDefault();

      if(!this.uid || !this.password || this.isLoading)
        return;

      this.$store.dispatch('login', {
        uid: this.uid,
        password: this.password
      })
        .then((res) => {
          this.$router.push('/calendar');
          if(this.$store.getters.rememberMe)
            this.setCookies(res);
        })
        .catch(err => this.isLoginError = true);
    },

    setCookie(name, value, expires) {
      document.cookie = name + "=" + value + "; expires=" + expires.toString() + "; path=/";
    },

    deleteCookie(name) {
      document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    },

    setCookies(data) {
      for(const [key, val] of Object.entries(data)) {
        this.setCookie(key, val, moment.unix(data.expires));
      };
    },
  },
  created() {

  }
}
</script>

<style lang="scss">
.card-rounded {
  border-radius: 3px;
}
</style>


// WEBPACK FOOTER //
// src/components/LoginForm.vue